import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceCustomerNotificationsRoute: InvariantJiraRoute = {
	name: 'csm-experience-customer-notifications',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/customer-notifications',
	exact: true,
};
